import { Injectable, signal, type Signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoadingScreenService {
  private _tokens = new Set<string>();
  private _timeouts = new Map<string, ReturnType<typeof setTimeout>>();
  private _defaultTimeoutMs = 30_000; // 30s failsafe per token

  private _loading = signal<boolean>(false);
  public readonly loading: Signal<boolean> = this._loading.asReadonly();

  private updateLoading(value: boolean): void {
    if (value && this._tokens.size === 0) {
      return;
    }
    this._loading.set(value);
  }

  show(timeoutMs?: number): string {
    const token = `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
    this._tokens.add(token);

    if (this._tokens.size === 1) {
      this.updateLoading(true);
    }

    const t = timeoutMs ?? this._defaultTimeoutMs;
    const timerId = setTimeout(() => {
      this._timeouts.delete(token);
      this._tokens.delete(token);
      if (this._tokens.size === 0) {
        this.updateLoading(false);
      }
    }, t);
    this._timeouts.set(token, timerId);

    return token;
  }

  hide(token?: string): void {
    if (token) {
      if (this._tokens.delete(token)) {
        const to = this._timeouts.get(token);
        if (to) {
          clearTimeout(to);
          this._timeouts.delete(token);
        }
      }
    } else {
      const it = this._tokens.values().next();
      if (!it.done) {
        const tkn = it.value;
        this._tokens.delete(tkn);
        const to = this._timeouts.get(tkn);
        if (to) {
          clearTimeout(to);
          this._timeouts.delete(tkn);
        }
      }
    }

    if (this._tokens.size === 0) {
      this.updateLoading(false);
    }
  }

  forceHide(): void {
    this._timeouts.forEach(to => clearTimeout(to));
    this._timeouts.clear();
    this._tokens.clear();
    this.updateLoading(false);
  }
}
